import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { loginSuccess } from "@store/member/memberAuthSlice";
import { setMemberInfoData } from "@store/member/memberInfoSlice";
import { getMemberProfile } from "@api/memberApi";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useLogoutAndClear } from "@utils/auth";

const useAuthSync = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const logoutAndClear = useLogoutAndClear(); 

  const { memberInfoData } = useSelector((state) => state.memberInfo);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const access_token = localStorage.getItem("access_token");
    const signature = localStorage.getItem("signature");
    const tokenExpireTime = localStorage.getItem("token_expire_time");

    // Step 1: 同步 localStorage → Redux
    if (access_token && signature) {
      dispatch(loginSuccess({ token: access_token, signature, tokenExpireTime }));
    }

    console.log("🔑 檢查會員登入狀態...");
    // Step 2: 撈會員資料
    const fetchMemberProfile = async () => {
      try {
        const res = await getMemberProfile();
        dispatch(setMemberInfoData(res.data.Data));
      } catch (err) {
        console.error("❌ 無效 token，自動登出", err);
        // toast.error("登入過期，請重新登入");
        logoutAndClear("/");
        console.log(err)
      } finally {
        setLoading(false);
      }
    };

    // Step 3: 有 token 才撈，無 token 或已登入過就略過
    if (access_token && signature && !memberInfoData) {
      fetchMemberProfile();
    } else {
      setLoading(false);
    }

    // Step 4: token 過期處理
    const now = Date.now();
    if (tokenExpireTime && Number(tokenExpireTime) < now) {
      console.warn("🔒 Token 已過期，自動登出");
      // toast.warning("登入已過期");
      logoutAndClear("/");
    }

  }, [dispatch, navigate]);

  return { loading };
};

export default useAuthSync;
